/* istanbul ignore file */
import _ from 'underscore';


export const validationUtility = {
  // emails can be delimited by , or ;
  areEmailsValid: (emails) => {
    // split, trim, remove empty entrys

    // emails are not required.
    if (!emails) return true;
    const emailList = _.filter(_.map(emails.split(/,|;/), item => item.trim()), item => item);
    if (!emailList || emailList.length === 0) {
      return true;
    }
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,8})+$/;
    return _.every(emailList, email => emailRegex.test(email.trim()));
  },

  isUrlValid: (url) => {
    const urlRegex = /^(?:(?:http[s]?|ftp):\/\/)(?:[^:/\s]+)(?:\/([^/]*))?(?:\/([^/]*))?/;
    return urlRegex.test(url.trim());
  },

  hasSuspiciousCharacters: (source) => {
    const suspUrl = /^[a-zA-Z]+:\/\//;
    const suspTag = /<.*?>/;
    return (suspUrl.test(source) || suspTag.test(source));
  },

  hasStoreNameDisallowedCharacters: (source) => {
    // International support: new pattern matcch \u00C0-\u017F
    // added into previous string to support accent chars
    const dis = /[^ \t\u2018\u2019\u201c\u201d\u00C0-\u017F~‘’｀´`\u2E80-\u2FD5\u3000-\u3096\u30A0-\u30FF\u3190-\u319F\u3400-\u4DBF\u4E00-\u9FCC\uF900-\uFAAD\uFF00-\uFFEFa-zA-Z0-9≪≫!@#$%^&*()_+‐＋\-={}…±×÷≠∞♯[\]:;“”〜"',.?/|\\]/;
    return dis.test(source);
  },

  hasStoreDescriptionDisallowedCharacters: (source) => {
    // International support: new pattern matcch \u00C0-\u017F
    // added into previous string to support accent chars
    const dis = /[^ \t\u2018\u2019\u201c\u201d\u00C0-\u017F~‘’｀´`\u2E80-\u2FD5\u3000-\u3096\u30A0-\u30FF\u3190-\u319F\u3400-\u4DBF\u4E00-\u9FCC\uF900-\uFAAD\uFF00-\uFFEFa-zA-Z0-9≪≫!@#$%^&*()_+‐＋\-={}…±×÷≠∞♯[\]:;“”〜"',.?/|\n\\]/;
    return dis.test(source);
  },

  hasStoreNameMustContainedCharacters: (source) => {
    // Japanese Store names can possibly have no english alphabets
    const m = /[a-zA-Z0-9\u2E80-\u2FD5\u3000-\u3096\u30A0-\u30FF\u3190-\u319F\u3400-\u4DBF\u4E00-\u9FCC\uF900-\uFAAD\uFF00-\uFFEF]/;
    return m.test(source);
  },

  hasAlphabetsOnly: (source) => {
    const allowedCharacters = /^[a-zA-Z]*$/;
    return allowedCharacters.test(source);
  },

  hasAlphanumeralsOnly: (source) => {
    const allowedCharacters = /^[a-zA-Z0-9]*$/;
    return allowedCharacters.test(source);
  },

  hasAlphanumeralsHyphensAndUnderscoresOnly: (source) => {
    const allowedCharacters = /^[a-zA-Z0-9_-]*$/;
    return allowedCharacters.test(source);
  },

  hasAlphanumeralsAndHyphensOnly: (source) => {
    const allowedCharacters = /^[a-zA-Z0-9-]*$/;
    return allowedCharacters.test(source);
  },

  validateStoreName: (i18n, name) => {
    if (!name) return [i18n.getString(_TL_('Enter a store name.'))];
    const maxLength = 70;

    const storeName = name.trim();
    if (storeName.length > maxLength) return [i18n.getString(_TL_('The store name must be between 1 and 70 characters long.'))];

    if (!validationUtility.hasStoreNameMustContainedCharacters(storeName)) return [i18n.getString(_TL_('Enter at least one letter or number.'))];

    if (validationUtility.hasSuspiciousCharacters(storeName)) return [i18n.getString(_TL_('Store name is invalid.'))];

    if (validationUtility.hasStoreNameDisallowedCharacters(storeName)) return [i18n.getString(_TL_('Store name cannot contain invalid characters.'))];

    return [];
  },

  validateStoreDescription: (i18n, description) => {
    if (!description) return [];

    const storeDesc = description.trim();
    const maxLength = 350;
    if (storeDesc.length > maxLength) return [i18n.getString(_TL_('Enter no more than {{maxLength}} characters.'), { maxLength })];

    if (validationUtility.hasStoreDescriptionDisallowedCharacters(storeDesc)) return [i18n.getString(_TL_('The store description cannot contain invalid characters.'))];

    return [];
  },

  validateFtpUsername: (value, i18n) => {
    if (!value) return [i18n.getString(_TL_('Enter a user name.'))];

    const maxLength = 64;
    const minLength = 6;
    const username = value.trim();

    if (!validationUtility.ftpUsernameMustContainCharacters(username)) {
      return [i18n.getString(_TL_('Enter at least one letter or one number.'))];
    }

    if (validationUtility.ftpUsernameHasDisallowedCharacters(username)) {
      return [i18n.getString(_TL_('Enter letters or numbers, not special characters.'))];
    }

    if (username.length > maxLength || username.length < minLength) {
      return [i18n.getString(_TL_('The user name must be between 6 and 64 characters long.'))];
    }

    if (validationUtility.hasSuspiciousCharacters(username)) {
      return [i18n.getString(_TL_('Enter a different user name because this one is not Cross Site Scripting safe.'))];
    }

    return [];
  },

  validateFtpPassword: (value, i18n) => {
    if (!value) return [i18n.getString(_TL_('Enter a password.'))];

    const maxLength = 64;
    const minLength = 6;
    const password = value.trim();

    if (password.length > maxLength || password.length < minLength) {
      return [i18n.getString(_TL_('The password must be between 6 and 64 characters long.'))];
    }

    if (!validationUtility.ftpPasswordMustContainCharacters(password)) {
      return [i18n.getString(_TL_('Enter at least one letter and one number.'))];
    }

    if (!validationUtility.ftpUsernameHasDisallowedCharacters(password)) {
      return [i18n.getString(_TL_('Enter at least one letter, one number, and one special character.'))];
    }

    if (validationUtility.hasSuspiciousCharacters(password)) {
      return [i18n.getString(_TL_('Enter a different password because this one is not Cross Site Scripting safe.'))];
    }

    return [];
  },

  confirmFtpPassword: (confirmFtpPassword, ftpPassword, i18n) => {
    if (ftpPassword && confirmFtpPassword !== ftpPassword.value) {
      return [i18n.getString(_TL_('Passwords do not match.'))];
    }
    return validationUtility.validateFtpPassword(confirmFtpPassword, i18n);
  },

  ftpUsernameMustContainCharacters: (value) => {
    const m = /[a-zA-Z0-9]/;
    return m.test(value);
  },

  ftpPasswordMustContainCharacters: (value) => {
    const mChars = /[a-zA-Z]/;
    const mNumbers = /[0-9]/;
    return mChars.test(value) && mNumbers.test(value);
  },

  ftpUsernameHasDisallowedCharacters: (value) => {
    const m = /^[a-zA-Z0-9]+$/;
    return !m.test(value);
  },

  validateCurrency: (value, i18n) => {
    const c = /^\d+(\.\d{0,2})?$/;

    if (!c.test(value)) {
      return [i18n.getString(_TL_('Invalid amount.'))];
    }

    return [];
  },

  validatePromotionAmount: (value, i18n, required, minimum, maximum) => {
    if (required && !value) {
      return [i18n.getString(_TL_('Required field'))];
    }

    if (!value) {
      return [];
    }

    const c = /^\d+(\.\d{0,2})?$/;
    const unformatValue = i18n.parseDecimal(value);
    if (!c.test(unformatValue)) {
      return [i18n.getString(_TL_('Invalid amount.'))];
    }

    if (minimum && value < minimum) {
      return [i18n.getString(_TL_('Number should be larger than {{min}}'), {
        min: minimum,
      })];
    }

    if (maximum && value > maximum) {
      return [i18n.getString(_TL_('Number should be smaller than {{max}}'), {
        max: maximum,
      })];
    }

    return [];
  },

  validatePromotionId: (value, i18n, isBLE = false) => {
    if (!value) {
      return [isBLE ? i18n.getString(_TL_('Enter a Brand Loyalty Extension ID.')) : i18n.getString(_TL_('Enter a Promotion ID.'))];
    }

    if (!validationUtility.hasAlphanumeralsHyphensAndUnderscoresOnly(value)) {
      return [isBLE ? i18n.getString(_TL_('Enter a valid brand loyalty ID. It should contain only alphabet letters, numbers, "-", "_".')) : i18n.getString(_TL_('Enter a valid Promotion ID. It should contain only alphabet letters, numbers, "-", "_"'))];
    }

    return [];
  },

  validatePromotionTitle: (value, i18n, isBLE = false) => {
    if (!value) {
      return [isBLE ? i18n.getString(_TL_('Enter a tooltip for your Brand Loyalty Extension.')) : i18n.getString(_TL_('Enter a title for your promotion.'))];
    }

    if (validationUtility.hasSuspiciousCharacters(value)) {
      return [isBLE ? i18n.getString(_TL_('Enter a valid tooltip for your Brand Loyalty Extension.')) : i18n.getString(_TL_('Enter a valid title for your promotion'))];
    }

    return [];
  },

  validatePromotionGenericRedemptionCode: (value, i18n, maxLength) => {
    if (!value) {
      return [i18n.getString(_TL_('Enter a redemption code.'))];
    }
    if (!validationUtility.hasAlphanumeralsHyphensAndUnderscoresOnly(value)) {
      return [i18n.getString(_TL_('Enter a valid redemption code, containing only alphanumeric characters, "-", "_".'))];
    }

    if (value.length > maxLength) {
      return [i18n.getString(_TL_('Redemption code cannot be more than {{maxLength}} characters.'), {
        maxLength,
      })];
    }

    return [];
  },

  validatePromotionFeedFilename: (filename, i18n) => {
    const allowedExtension = /(.*\\)?(.*)\.(tsv|xml|txt)/;

    if (validationUtility.hasSuspiciousCharacters(filename)) {
      return [i18n.getString(_TL_('Feed file name has invalid characters.'))];
    }

    if (!allowedExtension.test(filename)) {
      return [i18n.getString(_TL_('Feed file name has invalid file extension.'))];
    }

    return [];
  },

  validateFeedLabel: (i18n, name) => {
    if (!name) return [i18n.getString(_TL_('Required field'))];

    const feedLabel = name.trim();
    if (!validationUtility.hasAlphanumeralsAndHyphensOnly(feedLabel)) return [i18n.getString(_TL_('Only alphabet letters, numbers, "-", allowed.'))];

    return [];
  },

  validateAdditionalCountries: (i18n, additionalCountries) => {
    if (!additionalCountries || additionalCountries.length === 0) return [i18n.getString(_TL_('Required field'))];

    return [];
  },

  validateDestinations: (i18n, destinations) => {
    if (!destinations || destinations.length === 0) return [i18n.getString(_TL_('Required field'))];

    return [];
  },
};
